import {ActionTree, Module } from "vuex";
import store, {RootState} from "../store";


export class PlanMapState {

}

const state = new PlanMapState()

const actions: ActionTree<PlanMapState, RootState> = {

}


const mutations = {

}

const getters = {

};

const modules = {

}

export default class PlanMapModule implements Module<PlanMapState, RootState> {
  namespaced = true
  state = state
  actions = actions
  mutations = mutations
  getters = getters
  modules = modules
}
